module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./AddressListView.js"));
	}, "AddressListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AddressListView!./src/pages/Shop/Member/Address/AddressList/AddressListView.js
// module id = 1481
// module chunks = 418